import { FormlyFieldConfig, FormlyConfig } from '@ngx-formly/core';
export class TemplateValidation {
/**
 * @param {?} fc
 * @return {?}
 */
run(fc: FormlyConfig) {
    fc.templateManipulators.postWrapper.push((field: FormlyFieldConfig) => {
      if (field && field.validators) {
        return 'validation-message';
      }
    });
  }
}
